import type {
  KeywordLandingPageQuery,
  KeywordLandingPageQueryVariables,
} from 'src/types';
import keywordLandingPageQuery from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useKeywordLandingPageQuery(
  variables: KeywordLandingPageQueryVariables
) {
  return usePageQuery<KeywordLandingPageQuery>({
    query: keywordLandingPageQuery,
    routeName: 'keywordLandingPage',
    variables,
  });
}
